export default function SectionTitle({ title, children }) {
  return (
    <div className="relative mb-8 flex select-none items-center gap-4 pb-2 after:absolute after:bottom-0 after:h-[1px] after:w-full after:bg-section-divider after:content-['']">
      {children}
      <h2 className="text-xl font-medium uppercase tracking-[1px] text-portfolio-title">
        {title}
      </h2>
    </div>
  );
}
